// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   RESPONSIVE DESIGN SYSTEM
   Mobile-First Approach: 320px → 1920px
   ============================================ */

/* Base Variables */
:root {
  --mobile-padding: 1rem;
  --tablet-padding: 1.5rem;
  --desktop-padding: 2rem;
  --touch-target-min: 44px;
  --sidebar-width: 256px;
  --sidebar-collapsed: 64px;
}

/* ============================================
   RESPONSIVE UTILITIES
   ============================================ */

/* Container Utilities */
.container-responsive {
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  padding: var(--mobile-padding);
}

@media (min-width: 768px) {
  .container-responsive {
    padding: var(--tablet-padding);
  }
}

@media (min-width: 1024px) {
  .container-responsive {
    padding: var(--desktop-padding);
  }
}

/* Responsive Grid System */
.grid-responsive {
  display: grid;
  gap: 1rem;
  grid-template-columns: 1fr;
}

@media (min-width: 640px) {
  .grid-responsive-sm-2 {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 768px) {
  .grid-responsive-md-2 {
    grid-template-columns: repeat(2, 1fr);
  }
  .grid-responsive-md-3 {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (min-width: 1024px) {
  .grid-responsive-lg-3 {
    grid-template-columns: repeat(3, 1fr);
  }
  .grid-responsive-lg-4 {
    grid-template-columns: repeat(4, 1fr);
  }
}

/* ============================================
   TABLE RESPONSIVENESS
   ============================================ */

.table-responsive {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  border-radius: 0.5rem;
}

.table-responsive table {
  min-width: 800px;
  width: 100%;
}

@media (max-width: 768px) {
  .table-responsive table {
    font-size: 0.875rem;
  }
  
  .table-responsive th,
  .table-responsive td {
    padding: 0.5rem !important;
    white-space: nowrap;
  }
}

/* ============================================
   FORM RESPONSIVENESS
   ============================================ */

.form-responsive {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.form-row-responsive {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

@media (min-width: 768px) {
  .form-row-responsive {
    flex-direction: row;
  }
  
  .form-row-responsive > * {
    flex: 1 1;
  }
}

/* Form Input Sizing */
.input-responsive {
  width: 100%;
  min-height: var(--touch-target-min);
  padding: 0.75rem;
  font-size: 1rem;
  border-radius: 0.5rem;
  border: 1px solid #d1d5db;
}

@media (max-width: 768px) {
  .input-responsive {
    font-size: 16px; /* Prevents zoom on iOS */
  }
}

/* ============================================
   BUTTON RESPONSIVENESS
   ============================================ */

.btn-responsive {
  min-height: var(--touch-target-min);
  min-width: var(--touch-target-min);
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: all 0.2s;
}

@media (max-width: 768px) {
  .btn-responsive {
    width: 100%;
    padding: 1rem;
  }
}

/* ============================================
   MODAL RESPONSIVENESS
   ============================================ */

.modal-responsive {
  position: fixed;
  inset: 0;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  overflow-y: auto;
}

.modal-content-responsive {
  background: white;
  border-radius: 0.75rem;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  margin: auto;
}

@media (max-width: 768px) {
  .modal-responsive {
    padding: 0.5rem;
    align-items: flex-start;
  }
  
  .modal-content-responsive {
    max-width: 100%;
    max-height: 95vh;
    border-radius: 0.5rem;
    margin-top: 1rem;
  }
}

/* ============================================
   CARD RESPONSIVENESS
   ============================================ */

.card-responsive {
  background: white;
  border-radius: 0.75rem;
  padding: 1.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

@media (max-width: 768px) {
  .card-responsive {
    padding: 1rem;
    border-radius: 0.5rem;
  }
}

/* ============================================
   SIDEBAR RESPONSIVENESS
   ============================================ */

.sidebar-responsive {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: var(--sidebar-width);
  background: white;
  border-right: 1px solid #e5e7eb;
  transition: transform 0.3s ease;
  z-index: 40;
}

@media (max-width: 1024px) {
  .sidebar-responsive {
    transform: translateX(-100%);
  }
  
  .sidebar-responsive.open {
    transform: translateX(0);
  }
  
  .sidebar-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 30;
    display: none;
  }
  
  .sidebar-overlay.active {
    display: block;
  }
}

/* ============================================
   NAVIGATION RESPONSIVENESS
   ============================================ */

.nav-responsive {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  background: white;
  border-bottom: 1px solid #e5e7eb;
  position: sticky;
  top: 0;
  z-index: 20;
}

.hamburger-menu {
  display: none;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0.5rem;
  cursor: pointer;
  border: none;
  background: transparent;
}

.hamburger-menu span {
  width: 24px;
  height: 2px;
  background: #374151;
  transition: all 0.3s;
}

@media (max-width: 1024px) {
  .hamburger-menu {
    display: flex;
  }
}

/* ============================================
   TEXT RESPONSIVENESS
   ============================================ */

.text-responsive-xl {
  font-size: 1.5rem;
  line-height: 2rem;
}

.text-responsive-lg {
  font-size: 1.25rem;
  line-height: 1.75rem;
}

.text-responsive-base {
  font-size: 1rem;
  line-height: 1.5rem;
}

@media (min-width: 768px) {
  .text-responsive-xl {
    font-size: 2rem;
    line-height: 2.5rem;
  }
  
  .text-responsive-lg {
    font-size: 1.5rem;
    line-height: 2rem;
  }
}

@media (min-width: 1024px) {
  .text-responsive-xl {
    font-size: 2.5rem;
    line-height: 3rem;
  }
  
  .text-responsive-lg {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
}

/* ============================================
   SPACING UTILITIES
   ============================================ */

.spacing-responsive-sm {
  padding: 0.5rem;
}

.spacing-responsive-md {
  padding: 1rem;
}

.spacing-responsive-lg {
  padding: 1.5rem;
}

@media (min-width: 768px) {
  .spacing-responsive-sm {
    padding: 0.75rem;
  }
  
  .spacing-responsive-md {
    padding: 1.5rem;
  }
  
  .spacing-responsive-lg {
    padding: 2rem;
  }
}

/* ============================================
   HIDE/SHOW UTILITIES
   ============================================ */

.hide-mobile {
  display: none;
}

@media (min-width: 768px) {
  .hide-mobile {
    display: block;
  }
}

.show-mobile {
  display: block;
}

@media (min-width: 768px) {
  .show-mobile {
    display: none;
  }
}

.hide-tablet {
  display: none;
}

@media (min-width: 1024px) {
  .hide-tablet {
    display: block;
  }
}

/* ============================================
   CHART RESPONSIVENESS
   ============================================ */

.chart-responsive {
  width: 100%;
  height: 300px;
  min-height: 200px;
}

@media (min-width: 768px) {
  .chart-responsive {
    height: 400px;
  }
}

@media (min-width: 1024px) {
  .chart-responsive {
    height: 500px;
  }
}

/* ============================================
   IMAGE RESPONSIVENESS
   ============================================ */

.img-responsive {
  max-width: 100%;
  height: auto;
  display: block;
}

/* ============================================
   FLEX UTILITIES
   ============================================ */

.flex-responsive {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

@media (min-width: 768px) {
  .flex-responsive {
    flex-direction: row;
    align-items: center;
  }
}

/* ============================================
   SCROLLBAR STYLING
   ============================================ */

.scrollbar-thin::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.scrollbar-thin::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.scrollbar-thin::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.scrollbar-thin::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* ============================================
   PRINT STYLES
   ============================================ */

@media print {
  .no-print {
    display: none !important;
  }
  
  .sidebar-responsive,
  .hamburger-menu,
  .nav-responsive {
    display: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/responsive.css"],"names":[],"mappings":"AAAA;;;iDAGiD;;AAEjD,mBAAmB;AACnB;EACE,sBAAsB;EACtB,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;iDAEiD;;AAEjD,wBAAwB;AACxB;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,+BAA+B;EACjC;AACF;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;AACF;;AAEA;;iDAEiD;;AAEjD;EACE,WAAW;EACX,gBAAgB;EAChB,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;;IAEE,0BAA0B;IAC1B,mBAAmB;EACrB;AACF;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,SAAO;EACT;AACF;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE;IACE,eAAe,EAAE,yBAAyB;EAC5C;AACF;;AAEA;;iDAEiD;;AAEjD;EACE,mCAAmC;EACnC,kCAAkC;EAClC,uBAAuB;EACvB,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE;IACE,WAAW;IACX,aAAa;EACf;AACF;;AAEA;;iDAEiD;;AAEjD;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,+CAA+C;EAC/C,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;EAClB;AACF;;AAEA;;iDAEiD;;AAEjD;EACE,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE;IACE,aAAa;IACb,qBAAqB;EACvB;AACF;;AAEA;;iDAEiD;;AAEjD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,2BAA2B;EAC3B,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,8BAA8B;IAC9B,WAAW;IACX,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;;iDAEiD;;AAEjD;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;AACF;;AAEA;;iDAEiD;;AAEjD;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;AACf;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;;iDAEiD;;AAEjD;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;;iDAEiD;;AAEjD;EACE,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE;IACE,mBAAmB;IACnB,mBAAmB;EACrB;AACF;;AAEA;;iDAEiD;;AAEjD;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;iDAEiD;;AAEjD;EACE;IACE,wBAAwB;EAC1B;;EAEA;;;IAGE,wBAAwB;EAC1B;AACF","sourcesContent":["/* ============================================\n   RESPONSIVE DESIGN SYSTEM\n   Mobile-First Approach: 320px → 1920px\n   ============================================ */\n\n/* Base Variables */\n:root {\n  --mobile-padding: 1rem;\n  --tablet-padding: 1.5rem;\n  --desktop-padding: 2rem;\n  --touch-target-min: 44px;\n  --sidebar-width: 256px;\n  --sidebar-collapsed: 64px;\n}\n\n/* ============================================\n   RESPONSIVE UTILITIES\n   ============================================ */\n\n/* Container Utilities */\n.container-responsive {\n  width: 100%;\n  max-width: 1920px;\n  margin: 0 auto;\n  padding: var(--mobile-padding);\n}\n\n@media (min-width: 768px) {\n  .container-responsive {\n    padding: var(--tablet-padding);\n  }\n}\n\n@media (min-width: 1024px) {\n  .container-responsive {\n    padding: var(--desktop-padding);\n  }\n}\n\n/* Responsive Grid System */\n.grid-responsive {\n  display: grid;\n  gap: 1rem;\n  grid-template-columns: 1fr;\n}\n\n@media (min-width: 640px) {\n  .grid-responsive-sm-2 {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (min-width: 768px) {\n  .grid-responsive-md-2 {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  .grid-responsive-md-3 {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (min-width: 1024px) {\n  .grid-responsive-lg-3 {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  .grid-responsive-lg-4 {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n/* ============================================\n   TABLE RESPONSIVENESS\n   ============================================ */\n\n.table-responsive {\n  width: 100%;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  border-radius: 0.5rem;\n}\n\n.table-responsive table {\n  min-width: 800px;\n  width: 100%;\n}\n\n@media (max-width: 768px) {\n  .table-responsive table {\n    font-size: 0.875rem;\n  }\n  \n  .table-responsive th,\n  .table-responsive td {\n    padding: 0.5rem !important;\n    white-space: nowrap;\n  }\n}\n\n/* ============================================\n   FORM RESPONSIVENESS\n   ============================================ */\n\n.form-responsive {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.form-row-responsive {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n@media (min-width: 768px) {\n  .form-row-responsive {\n    flex-direction: row;\n  }\n  \n  .form-row-responsive > * {\n    flex: 1;\n  }\n}\n\n/* Form Input Sizing */\n.input-responsive {\n  width: 100%;\n  min-height: var(--touch-target-min);\n  padding: 0.75rem;\n  font-size: 1rem;\n  border-radius: 0.5rem;\n  border: 1px solid #d1d5db;\n}\n\n@media (max-width: 768px) {\n  .input-responsive {\n    font-size: 16px; /* Prevents zoom on iOS */\n  }\n}\n\n/* ============================================\n   BUTTON RESPONSIVENESS\n   ============================================ */\n\n.btn-responsive {\n  min-height: var(--touch-target-min);\n  min-width: var(--touch-target-min);\n  padding: 0.75rem 1.5rem;\n  font-size: 1rem;\n  border-radius: 0.5rem;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n@media (max-width: 768px) {\n  .btn-responsive {\n    width: 100%;\n    padding: 1rem;\n  }\n}\n\n/* ============================================\n   MODAL RESPONSIVENESS\n   ============================================ */\n\n.modal-responsive {\n  position: fixed;\n  inset: 0;\n  z-index: 50;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  overflow-y: auto;\n}\n\n.modal-content-responsive {\n  background: white;\n  border-radius: 0.75rem;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);\n  width: 100%;\n  max-width: 600px;\n  max-height: 90vh;\n  overflow-y: auto;\n  margin: auto;\n}\n\n@media (max-width: 768px) {\n  .modal-responsive {\n    padding: 0.5rem;\n    align-items: flex-start;\n  }\n  \n  .modal-content-responsive {\n    max-width: 100%;\n    max-height: 95vh;\n    border-radius: 0.5rem;\n    margin-top: 1rem;\n  }\n}\n\n/* ============================================\n   CARD RESPONSIVENESS\n   ============================================ */\n\n.card-responsive {\n  background: white;\n  border-radius: 0.75rem;\n  padding: 1.5rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n@media (max-width: 768px) {\n  .card-responsive {\n    padding: 1rem;\n    border-radius: 0.5rem;\n  }\n}\n\n/* ============================================\n   SIDEBAR RESPONSIVENESS\n   ============================================ */\n\n.sidebar-responsive {\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: var(--sidebar-width);\n  background: white;\n  border-right: 1px solid #e5e7eb;\n  transition: transform 0.3s ease;\n  z-index: 40;\n}\n\n@media (max-width: 1024px) {\n  .sidebar-responsive {\n    transform: translateX(-100%);\n  }\n  \n  .sidebar-responsive.open {\n    transform: translateX(0);\n  }\n  \n  .sidebar-overlay {\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.5);\n    z-index: 30;\n    display: none;\n  }\n  \n  .sidebar-overlay.active {\n    display: block;\n  }\n}\n\n/* ============================================\n   NAVIGATION RESPONSIVENESS\n   ============================================ */\n\n.nav-responsive {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem;\n  background: white;\n  border-bottom: 1px solid #e5e7eb;\n  position: sticky;\n  top: 0;\n  z-index: 20;\n}\n\n.hamburger-menu {\n  display: none;\n  flex-direction: column;\n  gap: 0.25rem;\n  padding: 0.5rem;\n  cursor: pointer;\n  border: none;\n  background: transparent;\n}\n\n.hamburger-menu span {\n  width: 24px;\n  height: 2px;\n  background: #374151;\n  transition: all 0.3s;\n}\n\n@media (max-width: 1024px) {\n  .hamburger-menu {\n    display: flex;\n  }\n}\n\n/* ============================================\n   TEXT RESPONSIVENESS\n   ============================================ */\n\n.text-responsive-xl {\n  font-size: 1.5rem;\n  line-height: 2rem;\n}\n\n.text-responsive-lg {\n  font-size: 1.25rem;\n  line-height: 1.75rem;\n}\n\n.text-responsive-base {\n  font-size: 1rem;\n  line-height: 1.5rem;\n}\n\n@media (min-width: 768px) {\n  .text-responsive-xl {\n    font-size: 2rem;\n    line-height: 2.5rem;\n  }\n  \n  .text-responsive-lg {\n    font-size: 1.5rem;\n    line-height: 2rem;\n  }\n}\n\n@media (min-width: 1024px) {\n  .text-responsive-xl {\n    font-size: 2.5rem;\n    line-height: 3rem;\n  }\n  \n  .text-responsive-lg {\n    font-size: 1.875rem;\n    line-height: 2.25rem;\n  }\n}\n\n/* ============================================\n   SPACING UTILITIES\n   ============================================ */\n\n.spacing-responsive-sm {\n  padding: 0.5rem;\n}\n\n.spacing-responsive-md {\n  padding: 1rem;\n}\n\n.spacing-responsive-lg {\n  padding: 1.5rem;\n}\n\n@media (min-width: 768px) {\n  .spacing-responsive-sm {\n    padding: 0.75rem;\n  }\n  \n  .spacing-responsive-md {\n    padding: 1.5rem;\n  }\n  \n  .spacing-responsive-lg {\n    padding: 2rem;\n  }\n}\n\n/* ============================================\n   HIDE/SHOW UTILITIES\n   ============================================ */\n\n.hide-mobile {\n  display: none;\n}\n\n@media (min-width: 768px) {\n  .hide-mobile {\n    display: block;\n  }\n}\n\n.show-mobile {\n  display: block;\n}\n\n@media (min-width: 768px) {\n  .show-mobile {\n    display: none;\n  }\n}\n\n.hide-tablet {\n  display: none;\n}\n\n@media (min-width: 1024px) {\n  .hide-tablet {\n    display: block;\n  }\n}\n\n/* ============================================\n   CHART RESPONSIVENESS\n   ============================================ */\n\n.chart-responsive {\n  width: 100%;\n  height: 300px;\n  min-height: 200px;\n}\n\n@media (min-width: 768px) {\n  .chart-responsive {\n    height: 400px;\n  }\n}\n\n@media (min-width: 1024px) {\n  .chart-responsive {\n    height: 500px;\n  }\n}\n\n/* ============================================\n   IMAGE RESPONSIVENESS\n   ============================================ */\n\n.img-responsive {\n  max-width: 100%;\n  height: auto;\n  display: block;\n}\n\n/* ============================================\n   FLEX UTILITIES\n   ============================================ */\n\n.flex-responsive {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n@media (min-width: 768px) {\n  .flex-responsive {\n    flex-direction: row;\n    align-items: center;\n  }\n}\n\n/* ============================================\n   SCROLLBAR STYLING\n   ============================================ */\n\n.scrollbar-thin::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n.scrollbar-thin::-webkit-scrollbar-track {\n  background: #f1f5f9;\n  border-radius: 3px;\n}\n\n.scrollbar-thin::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 3px;\n}\n\n.scrollbar-thin::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n/* ============================================\n   PRINT STYLES\n   ============================================ */\n\n@media print {\n  .no-print {\n    display: none !important;\n  }\n  \n  .sidebar-responsive,\n  .hamburger-menu,\n  .nav-responsive {\n    display: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
